import { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../sharedUI/Button";
import Input from "../../sharedUI/Input";

const StyledCourseForm = styled.div`
  color: white;
  form {
    display: flex;
    flex-direction: column;
  }
`;

const CourseForm = ({ handleSubmit, data }) => {
  const initialCourse = {
    name: "",
    description: [""],
    descriptionLong: [""],
    mainImage: "",
    published: false,
    testQuestions: [],
  };

  const [formData, setFormData] = useState(initialCourse);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (data) setFormData(data);
  }, [data]);

  return (
    <StyledCourseForm>
      <form
        onSubmit={(e) => {
          setLoading(true);
          e.preventDefault();
          handleSubmit(
            formData,
            () => {
              setFormData(initialCourse);
              setLoading(false);
            },
            () => {
              setLoading(false);
            }
          );
        }}
      >
        <Input
          label="Kursens namn"
          type="text"
          value={formData.name}
          onChange={handleChange}
          name="name"
          placeholder="Kursnamn"
          required
          disabled={loading}
        />
        <div className="flex jce">
          <Button type="submit" disabled={loading}>
            {loading ? "Sparar..." : "Gå vidare"}
          </Button>
        </div>
      </form>
    </StyledCourseForm>
  );
};

export default CourseForm;
